import Logger from '../logger';

let inactivityTimer;
let resetInactivityTimer;
let events = ['mousemove', 'keydown', 'scroll', 'touchstart'];

const clearInactivityTimer = () => {
    clearTimeout(inactivityTimer);
    events.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer);
    });
};

const startInactivityMonitor = (args, callback) => {
    if (
        !args.chatInviteIconOptions?.tipOptions?.inactiveShowAfter ||
        args.chatInviteIconOptions.tipOptions.inactiveShowAfter === 0
    ) {
        return;
    }

    let inactivityTime = args.chatInviteIconOptions.tipOptions.inactiveShowAfter * 1000;

    // Function to reset the timer
    resetInactivityTimer = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => {
            events.forEach((event) => {
                window.removeEventListener(event, resetInactivityTimer);
            });
            Logger.log('user is inactive');
            callback && callback(args);
        }, inactivityTime);
    };

    // Event listeners to detect user activity
    events.forEach((event) => {
        window.addEventListener(event, resetInactivityTimer);
    });

    // Initialize the inactivity timer when the page loads
    resetInactivityTimer();
};

export { startInactivityMonitor, clearInactivityTimer };
